import { fetchToken } from './actions';
import { reducer } from './reducer';

const companyModule = () => ({
  id: 'Company',
  reducerMap: {
    Company: reducer,
  },
  initialActions: [fetchToken()],
  finalActions: [],
});

export { companyModule };
